import ProductAjaxService from "./ProductAjaxService";

export default class CartActions extends ProductAjaxService {
    constructor() {
        super();
        this.addToCart();
        this.addToCartArray();
        this.deleteFromCart();
        this.setCount();
    }

    //After load page
    getCart() {
        this._GET(this.getCartURL, this.updateSmallCarts);
    }

    addToCart() {
        let self = this;
        $(document).on('click', '.add_to_cart:not(.disabled)', function (e) {
            e.preventDefault();
            let ID = $(this).attr('data-id');
            if(!ID) {
                console.warn('Please set product ID');
                return false;
            }
            self._POST(self.addToCartURL, {product_id: ID}, self.updateSmallCarts);
            $('.add_to_cart[data-id='+ ID +']').addClass('active active--green');
        });
    }

    addToCartArray() {
        let self = this;
        $(document).on('click', '.add_to_cart_arr:not(.disabled)', function (e) {
            e.preventDefault();
            let IDS = $(this).attr('data-ids');
            if(!IDS) {
                console.warn('Please set product ID');
                return false;
            }
            self._POST(self.addToCartIdsURL, {product_ids: IDS}, self.updateSmallCarts);
            IDS.split(',').forEach(function (item) {
                $('.add_to_cart[data-id='+ item +']').addClass('active active--green');
            });
        });
    }

    deleteFromCart() {
        let self = this;
        $(document).on('click', '.delete_from_cart', function (e) {
            e.preventDefault();
            let ID = $(this).attr('data-id'),
                confName = 'confirm:delete';
            if(!ID) {
                console.warn('Please set product ID');
            }

            let headerCart = $(this).closest('#cart_desktop').length;

            //Confirm delete
            if(headerCart) {
                self._POST(self.deleteCartURL, {product_id: ID}, self.updateSmallCarts);
                $('.add_to_cart[data-id='+ ID +']').removeClass('active active--green');
            } else {
                $(document).bind(confName, function () {
                    $(document).unbind(confName);
                    self._POST(self.deleteCartURL, {product_id: ID}, self.updateSmallCarts);
                    $('.add_to_cart[data-id='+ ID +']').removeClass('active active--green');
                });
            }

            //Checking, close all or only confirm popup
            if(!headerCart) {
                if ($('#added_to_cart').css('display') !== 'block') {
                    self.confirmDelete(confName, true);
                } else {
                    self.confirmDelete(confName);
                }
            }
        });
    }

    setCount() {
        let self = this,
            timer = '';
        $(document).bind('trigger.count.product', function (e, id, count) {
            clearTimeout(timer);
            timer = setTimeout(function () {
                self._POST(self.setCartURL, {product_id: id, count: count}, self.updateSmallCarts);
            }, 1000);
        });
    }

    updateSmallCarts(res) {
        if(res.success) {
            if(res.data.count > 0) {
                $('.hover_item .cart_icon, .menu_slide .cart_icon')
                    .removeClass('icon-shopping_cart')
                    .addClass('icon-shopping_cart_on')
                    .parent().addClass('icon_indicator');

                if($(window).width() >= 1200) {
                    $('.ajax_small_items').each(function () {
                        if($(this).find('.ajax_small_items.scroll-content').length) {
                            $('.ajax_small_items.scroll-content').html(res.data.html);
                        } else {
                            $(this).html(res.data.html);
                            $(this).addClass('scrollbar-inner');

                            //Custom scroll
                            $(this).scrollbar();
                        }
                    })
                } else {
                    $('.ajax_small_items').html(res.data.html);
                }
                $('.menu_slide .cart_icon + span strong').html(res.data.count);

                //Remove confirm delete from header cart
                $('#cart_desktop .ajax_small_items .delete_from_cart').removeClass('fade-popup');

                //Price
                let $priceMain = $('.ajax_price_info_main'),
                    $pricePromo = $('.ajax_price_info_promo'),
                    $priceTotal = $('.ajax_price_info_total');

                let prValue = (res.data.price_old > 0) ? res.data.price_old : res.data.price;
                $priceMain.find('.pr_value').html(prValue.toLocaleString('ru-RU', {maximumFractionDigits: 2, minimumFractionDigits: 2}));

                if(res.data.price_promo > 0) {
                    $pricePromo.removeAttr('style');
                    $pricePromo.find('.pr_value').html('- ' + res.data.price_promo.toLocaleString('ru-RU', {maximumFractionDigits: 2, minimumFractionDigits: 2}));
                } else {
                    $pricePromo.attr('style', 'display:none !important');
                }
                $priceTotal.html(res.data.price.toLocaleString('ru-RU', {maximumFractionDigits: 2, minimumFractionDigits: 2}));

                //Header price
                $('.ajax_h_count').html(res.data.count + ' ' + res.data.count_text);
                $('.ajax_h_price').html(res.data.price.toLocaleString('ru-RU', {maximumFractionDigits: 2, minimumFractionDigits: 2}));

                //Show content
                $('.ajax_content_cart_true').show();
                $('.ajax_content_cart_false').hide();
            } else {
                $('.hover_item .cart_icon, .menu_slide .cart_icon')
                    .removeClass('icon-shopping_cart_on')
                    .addClass('icon-shopping_cart')
                    .parent().removeClass('icon_indicator');

                $('.ajax_small_items').html('');
                $('.menu_slide .cart_icon + span strong').html('');

                //Hide content
                $('.ajax_content_cart_true').hide();
                $('.ajax_content_cart_false').show();

                //Close popup
                $('#added_to_cart .header .icon-clear').trigger('click');
            }
            if(res.data.is_add) {
                $(document).trigger('trigger.show.popup', ['#added_to_cart', '.product_wrap']);
            }
        }
    }
}
